import get from 'lodash/get';
import compact from 'lodash/compact';
import Catalyst from '@Services/Catalyst';
import { concatLowerCase } from '@Utils/String';

export function generatePreviewTrackingSections(feature, contextTitle = '') {
  return compact([Catalyst.getPrefix(), 'query', 'preview', concatLowerCase(contextTitle), feature]);
}
export function trackPreviewFeature(feature, resultItem) {
  const sections = generatePreviewTrackingSections(feature, get(resultItem, 'title'));

  Catalyst.trackProductFeature(sections.join(':'));
}
